import { useCallback } from "react";

export function useCloseWindow(merchantUrl: string) {
  return useCallback(() => {
    try {
      if (!window.opener) {
        throw new Error("No opener specified.");
      }
      window.close();
    } catch {
      window.location.href = merchantUrl;
    }
  }, [merchantUrl]);
}
